module.exports = __webpack_public_path__ + "fonts/807a8ba.eot";